import { call, delay, put, select } from 'redux-saga/effects';
import ForgeRockApi from '../apis/ForgeRockApi';
import FORGEROCK_ACTION_TYPES from '../actionTypes/ForgeRock';

export const qrValue = ({qrValue}) => qrValue.qrValue;

/**
 * @name get Forgerock Api
 * @description get Forgerock value
 */
export function* getForgerockAuthValue() {
  try {
    const forgerock_authorized = yield select(qrValue);
    if (true) {
      yield delay(2000);
      const response = yield call(ForgeRockApi.post, forgerock_authorized.device_code);
      const payload = response || {};
      yield put({
        type: FORGEROCK_ACTION_TYPES.AUTHORIZED_SUCCESS,
        payload,
      });
    }
  } catch (error) {
    yield put({
      type: FORGEROCK_ACTION_TYPES.AUTHORIZED_ERROR,
      error,
    });
  }
}
